import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Header from "./components/Header";
import Home from "./pages/Home";
import ToS from "./pages/ToS";
import Contact from "./pages/Contact";
import Layout from "./components/Layout";
import { ThemeProvider } from "./context/ThemeContext";
import DarkMode from "./components/DarkMode";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Layout>
          <div className="min-h-screen bg-gradient-to-br duration-700 ease-in-out from-cyan-500 to-blue-600 dark:from-gray-900 dark:to-gray-700 text-white relative">
            <Analytics />
            <DarkMode />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tos" element={<ToS />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </div>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
